import { PlotContentSettings } from "../../../../settings/view-objects/plot/plot-content-settings";
import { SettingsParser } from "../../../settings-parser";

export class PlotContentParser extends SettingsParser {
  constructor(settingsParser) {
    super();
    this.parsedFieldNames = ["type", "name", "place", "settings"];
    this.settingsParser = settingsParser;
  }

  static createSettings(settings, defaultSettings, settingsParser) {
    if (settings === undefined || settings.type === undefined) {
      if (defaultSettings !== undefined) {
        let parsedSettings = {
          type: defaultSettings.type,
          name: defaultSettings.name,
          place: defaultSettings.place
        };
        if (defaultSettings.settings !== undefined && settingsParser !== undefined) {
          parsedSettings.settings = settingsParser.parse(settings?.settings, defaultSettings.settings);
        }
        return parsedSettings;
      }
      return undefined;
    }
    let parsedSettings = {
      type: settings.type,
      name: settings.name,
      place: settings.place
    };
    if (settings.settings !== undefined && settingsParser !== undefined) {
      parsedSettings.settings = settingsParser.parse(settings.settings, defaultSettings?.settings);
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = PlotContentParser.createSettings(settings, defaultSettings, this.settingsParser);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new PlotContentSettings(parsedSettings);
  }
}
